import React, {Component} from 'react';
import {errorMessageStyle, controlMaxWidthStyle, controlButtonStyle} from '../styles';
import AdminService from './admin-service';

class AddOrEditUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: props.user,
            isSaving: false,
            isActivating: false,
            errorMessage: ''
        };
        this.service = AdminService
    }

    inputChanged = e => {
        const user = this.state.user;
        user[e.target.id] = e.target.value;
        this.setState({user: user});
    };

    toggleIsAdmin = () => {
        const user = this.state.user;
        user.isAdmin = !user.isAdmin;
        this.setState({user: user})
    };

    saveUser = () => {
        this.setState({isSaving: true});
        this.service.saveUser(this.state.user)
            .done(() => this.props.onClose())
            .fail(e => this.setState({errorMessage: e.responseText}))
            .always(() => this.setState({isSaving: false}))
    };

    activateUser = () => {
        this.setState({isActivating: true});
        this.service.activateUser(this.state.user)
            .done(() => {
                const user = this.state.user;
                user.isActive = true;
                this.setState({user: user})
            })
            .fail(e => this.setState({errorMessage: e.responseText}))
            .always(() => this.setState({isActivating: false}))
    };

    render() {
        return (
            <div style={{marginTop: '20px'}}>
                <h4>{this.props.isAddUser ? 'Add User' : 'Edit User'}</h4>
                <form className="form-horizontal">
                    <div className="form-group">
                        <label htmlFor="firstName" className="col-sm-2 control-label">First name</label>
                        <div className="col-sm-10">
                            <input type="text"
                                   className="form-control"
                                   style={controlMaxWidthStyle}
                                   id="firstName"
                                   placeholder="First name"
                                   value={this.state.user.firstName}
                                   onChange={this.inputChanged}/>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="lastName" className="col-sm-2 control-label">Last name</label>
                        <div className="col-sm-10">
                            <input type="text"
                                   className="form-control"
                                   style={controlMaxWidthStyle}
                                   id="lastName"
                                   placeholder="Last name"
                                   value={this.state.user.lastName}
                                   onChange={this.inputChanged}/>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="companyName" className="col-sm-2 control-label">Company name</label>
                        <div className="col-sm-10">
                            <input type="text"
                                   className="form-control"
                                   style={controlMaxWidthStyle}
                                   id="companyName"
                                   placeholder="Company name"
                                   value={this.state.user.companyName}
                                   onChange={this.inputChanged}/>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="role" className="col-sm-2 control-label">Role</label>
                        <div className="col-sm-10">
                            <input type="text"
                                   className="form-control"
                                   style={controlMaxWidthStyle}
                                   id="role"
                                   placeholder="Role"
                                   value={this.state.user.role}
                                   onChange={this.inputChanged}/>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="telephone" className="col-sm-2 control-label">Telephone</label>
                        <div className="col-sm-10">
                            <input type="text"
                                   className="form-control"
                                   style={controlMaxWidthStyle}
                                   id="telephone"
                                   placeholder="Telephone"
                                   value={this.state.user.telephone}
                                   onChange={this.inputChanged}/>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="telephone" className="col-sm-2 control-label">Linked-in profile</label>
                        <div className="col-sm-10">
                            <input type="text"
                                   className="form-control"
                                   style={controlMaxWidthStyle}
                                   id="linkedInProfileUrl"
                                   placeholder="Linked In Profile URL"
                                   value={this.state.user.linkedInProfileUrl}
                                   onChange={this.inputChanged}/>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="email" className="col-sm-2 control-label">Email</label>
                        <div className="col-sm-10">
                            <input type="text"
                                   className="form-control"
                                   style={controlMaxWidthStyle}
                                   id="email"
                                   placeholder="Email"
                                   value={this.state.user.email}
                                   onChange={this.inputChanged}/>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="col-sm-offset-2 col-sm-10">
                            <div className="checkbox">
                                <label>
                                    <input id="isAdmin"
                                           type="checkbox"
                                           checked={this.state.user.isAdmin}
                                           onChange={this.toggleIsAdmin}/> Is Admin
                                </label>
                            </div>
                        </div>
                    </div>
                    {!this.state.user.isActive && !this.props.isAddUser ?
                        <div className="form-group">
                            <div className="col-sm-offset-2 col-sm-10">
                                <button type="button"
                                        className="btn btn-default"
                                        disabled={this.state.isActivating}
                                        onClick={this.activateUser}>
                                    {this.state.isActivating ? 'Activating...' : 'Activate'}
                                </button>
                            </div>
                        </div>
                        : undefined
                    }
                    <hr style={{margin: '20px 0px 20px 0px'}}/>
                    <div className="form-group">
                        <div className="col-sm-offset-2 col-sm-10">
                            <button type="button"
                                    className="btn btn-default"
                                    disabled={this.state.isSaving}
                                    onClick={this.saveUser}>
                                {this.state.isSaving ? 'Saving...' : 'Save'}
                            </button>
                            <button type="button"
                                    className="btn btn-default"
                                    style={{marginLeft: '15px'}}
                                    onClick={this.props.onClose}>Close</button>
                        </div>
                    </div>
                    {this.state.errorMessage ?
                        <div className="col-sm-offset-2 col-sm-10" style={{padding: '4px'}}>
                            <div className="alert alert-danger" style={errorMessageStyle} >{this.state.errorMessage}</div>
                        </div>
                        : undefined}
                </form>
            </div>
        )
    }
}

class UserList extends Component {
    constructor(props) {
        super(props);
        this.service = AdminService;
        this.state = {
            isLoading: true,
            errorMessage: '',
            users: []
        }
    }

    componentDidMount() {
        this.refreshData()
    }

    refreshData = () => {
        this.setState({isLoading: true});
        this.service.listUsers()
            .done(users => this.setState({users: users}))
            .fail(e => this.setState({errorMessage: e.responseText}))
            .always(() => this.setState({isLoading: false}))
    };

    render() {
        const loadingSpinner = this.state.isLoading ? <span className="spinner"></span> : undefined;

        const errorMessage = this.state.errorMessage ?
            <div className="alert alert-danger" style={errorMessageStyle}>{this.state.errorMessage}</div>
            : undefined;

        const userRows =
            this.state.users.map(u =>
                <tr>
                    <td>{u.firstName}</td>
                    <td>{u.lastName}</td>
                    <td>{u.email}</td>
                    <td>{u.isActive ? <span className="glyphicon glyphicon-ok"></span> : <span className="glyphicon glyphicon-remove"></span>}</td>
                    <td>{u.isAdmin ? <span className="glyphicon glyphicon-ok"></span> : <span className="glyphicon glyphicon-remove"></span>}</td>
                    <td>
                        <span className="glyphicon glyphicon-edit clickable"
                              title="Edit User"
                              onClick={() => this.props.onEditUser(u)}></span>
                    </td>
                </tr>);

        return (
            <div>
                {errorMessage}
                <div style={{marginBottom: '5px'}}>
                    <button className="btn btn-default"
                            style={controlButtonStyle}
                            disabled={this.state.isLoading}
                            onClick={() => this.refreshData()}>
                        <span className="glyphicon glyphicon-refresh"></span>&nbsp;Refresh
                    </button>
                    <button className="btn btn-default"
                            style={{...controlButtonStyle, ...{marginLeft: '10px'}}}
                            onClick={() => this.props.onAddUser()}>
                        <span className="glyphicon glyphicon-plus"></span>&nbsp;Add User
                    </button>
                    <div className="pull-right">{loadingSpinner}</div>
                </div>
                <table className="table table-striped small">
                    <thead>
                    <tr>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Email</th>
                        <th>Active</th>
                        <th>Admin</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    {userRows}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default class UserConsole extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAddUser: false,
            addOrEditUser: undefined
        }
    }

    render() {
        if (this.state.addOrEditUser) {
            return <AddOrEditUser isAddUser={this.state.isAddUser}
                                  user={this.state.addOrEditUser}
                                  onClose={() => this.setState({addOrEditUser: undefined, isAddUser: false})}/>
        } else {
            return <UserList onAddUser={() => this.setState({addOrEditUser: {}, isAddUser: true})}
                             onEditUser={user => this.setState({addOrEditUser: user})}/>
        }
    }
}


// WEBPACK FOOTER //
// ./src/admin/users.js